import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.074 18.048l-.458-.468C2.486 16.035 2 13.875 2 11.345c0-3.746 2.127-7.079 6.342-9.11 1.24-.597 2.65-.962 4.197-1.128 2.125-.228 4.366-.077 6.548.311.88.157 1.552.315 1.87.407 1.77.393 2.288 2.232.91 3.515-.116.095-.342.298-.64.596a15.464 15.464 0 0 0-1.489 1.722c-1.152 1.555-1.897 3.188-2.06 4.817-.503 5.043-3.453 7.658-8.244 7.658-1.87 0-3.336-.432-4.453-1.212a19.56 19.56 0 0 0 .017 3.534.5.5 0 0 1-.996.09c-.144-1.588-.12-3.088.072-4.497zm1.063-.343l.321.328c.98.72 2.292 1.1 3.976 1.1 4.325 0 6.802-2.273 7.25-6.757.176-1.774.956-3.567 2.251-5.313.485-.653 1.02-1.27 1.585-1.834.283-.283.54-.52.665-.62.78-.727.551-1.587-.504-1.823a20.2 20.2 0 0 0-1.769-.383c-2.226-.396-4.346-.508-6.266-.301-1.473.158-2.765.502-3.87 1.034C5 4.956 3 7.894 3 11.345c0 2.331.433 4.171 1.292 5.458 1.01-4.668 4.011-8.264 8.984-10.75a.5.5 0 1 1 .448.894c-4.941 2.47-7.796 6.043-8.587 10.758z"
});

var SvgOrganic = function SvgOrganic(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgOrganic;